import algoliasearch from 'algoliasearch';

// Initialize Algolia client
const client = algoliasearch(
  process.env.ALGOLIA_APPLICATION_ID,
  process.env.ALGOLIA_SEARCH_API_KEY
);
const index = client.initIndex('products');

/**
 * Parse URL and extract query and filters
 * @param {string} url - The URL to parse
 * @returns {Object} - An object containing the query and filters
 */
const parseUrl = (url) => {
  const urlParams = new URLSearchParams(url.split('?')[1]);
  const query = urlParams.get('query') || '';
  const facetFilters = [];
  const numericFilters = [];

  const refinementList = {};

  urlParams.forEach((value, key) => {
    if (key.startsWith('products[refinementList]')) {
      let actualKey = key.replace(/\]\[\d+\]/g, '');
      actualKey = actualKey.replace('products[refinementList][', '').replace('][]', '');
      if (!refinementList[actualKey]) {
        refinementList[actualKey] = [];
      }
      refinementList[actualKey].push(value);
    }
    if (key.startsWith('products[numericMenu]')) {
      const actualKey = key.replace('products[numericMenu][', '').replace(']', '');
      if (value.includes(':')) {
        const [min, max] = value.split(':');
        if (min && max) {
          numericFilters.push(`${actualKey}>=${min}`, `${actualKey}<=${max}`);
        } else if (max) {
          numericFilters.push(`${actualKey}<=${max}`);
        }
      }
    }
  });

  Object.keys(refinementList).forEach((key) => {
    if (refinementList[key].length > 1) {
      facetFilters.push(refinementList[key].map(value => `${key}:${value}`));
    } else {
      facetFilters.push(`${key}:${refinementList[key][0]}`);
    }
  });

  return { query, facetFilters, numericFilters };
};

/**
 * Check if a URL with query parameters will return a product using Algolia Search API
 * @param {string} url - The URL to check
 * @returns {Promise<boolean>} - Returns true if products are found, otherwise false
 */
export const checkIfProductExists = async (url) => {
  try {
    const { query, facetFilters, numericFilters } = parseUrl(url);

    // const result = await index.search('products', {
    //   facetFilters: [
    //     'named_tags.categories.lvl0:Clothing',  // Filter by category
    //     // 'meta.custom.us_size:29',
    //     // 'named_tags.categories.lvl1:Clothing > Jeans',
    //     // 'named_tags.categories.lvl2:Clothing > Jeans > Cropped'
    //   ],
    //   filters: 'inventory_quantity>0',    // Additional filter by price
    //   hitsPerPage: 1
    // });
    // console.log(result)

    // return result?.nbHits ? true : false;



    const result = await index.search('', {
      facetFilters: facetFilters,
      filters: 'inventory_quantity>0',    // Additional filter by price
      numericFilters: numericFilters,
      hitsPerPage: 1
    });
    console.log(result)

    return result?.nbHits ? true : false;
  } catch (error) {
    console.error('Error checking product existence:', error);
    return false;
  }
};